import React from 'react';
import { Empty, Icon } from 'antd';
import cn from 'classnames';
import RequestCountCardSkeleton from '../skeletons/RequestCountCardSkeleton/RequestCountCardSkeleton';
import styles from './RequestCountCard.module.scss';
import { ReactComponent as AllRequests } from '../../../../resource/statistics/allRequests.svg';
import { ReactComponent as NewRequests } from '../../../../resource/statistics/newRequests.svg';
import { ReactComponent as EmergencyRequests } from '../../../../resource/statistics/emergencyRequests.svg';
import { ReactComponent as ExpiredRequests } from '../../../../resource/statistics/expiredRequests.svg';
import { ReactComponent as RepeatRequests } from '../../../../resource/statistics/repeatRequests.svg';
import { ReactComponent as PaidRequests } from '../../../../resource/statistics/paidRequests.svg';
import { ReactComponent as TimeRequests } from '../../../../resource/statistics/timeRequests.svg';
import { RequestCountCardChart } from './components/RequestCountCardChart/RequestCountCardChart';

const icons = {
  'Всего заявок': AllRequests,
  Новые: NewRequests,
  Аварийные: EmergencyRequests,
  Просроченные: ExpiredRequests,
  'Открытые повторно': RepeatRequests,
  Платные: PaidRequests,
  'Время жизни заявки (дн.)': TimeRequests,
};

const chartTitles = ['Всего заявок', 'Новые', 'Аварийные', 'Просроченные'];

const RequestCountCard = ({
  title,
  requestCount,
  subtitle,
  className,
  loading = false,
  hasLink = false,
  description = 'Нет данных',
  chartData = [],
}) => {
  if (loading) {
    return <RequestCountCardSkeleton className={className} />;
  }

  return (
    <div
      className={cn(styles.root, className, { [styles.clickable]: hasLink })}
    >
      <div className={styles.header}>
        <span className={styles.anticon}>
          {icons[title] && (
            <Icon
              component={icons[title]}
              className={styles.icon}
            />
          )}{' '}
        </span>
        <h4 className={cn(styles.text, styles.title)}>{title}</h4>
      </div>
      {requestCount === undefined || isNaN(requestCount) ? (
        <Empty
          className={styles.empty}
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={description}
        />
      ) : (
        <div className={styles.content}>
          <p className={cn(styles.text, styles.count)}>{requestCount}</p>
          {chartTitles.includes(title) && (
            <RequestCountCardChart data={chartData} />
          )}
        </div>
      )}
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
    </div>
  );
};

export default RequestCountCard;
